
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PhotoUpload } from "@/components/PhotoUpload";

interface ProfilePhotoSectionProps {
  photos: string[];
  onPhotosChange: (photos: string[]) => void;
}

export const ProfilePhotoSection = ({ photos, onPhotosChange }: ProfilePhotoSectionProps) => {
  return (
    <Card className="mb-6 bg-carbon border-ice-white/10">
      <CardContent>
        <PhotoUpload 
          photos={photos}
          onPhotosChange={onPhotosChange}
          maxPhotos={5}
        />
      </CardContent>
    </Card>
  );
};
